export default angular.module('eventix.dashboard.wizard.advanced.shops', [])
    .config(ModuleConfig).name;

function ModuleConfig($stateProvider) {
    $stateProvider.state('eventix.dashboard.wizard.advanced.shops', {
        url: '/shops',
        component: 'wizardShops',
        bindings: {
            event: 'currentEvent',
            company: 'company'
        }
    });
    $stateProvider.state('eventix.dashboard.wizard.advanced.shops.collapses', {
        url: '/:shopGuid/collapses',
        views: {
            '@eventix.dashboard.wizard': {
                component: 'shopCollapses',
                bindings: {
                    event: 'currentEvent',
                    shop: 'shop'
                }
            }
        },
        resolve: {
            shop: function($transition$, Shop) {
                let params = $transition$.params();
                return Shop.get({ guid: params.shopGuid });
            }
        }
    });
}
